import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "_mt-5" }
const _hoisted_2 = {
  key: 0,
  class: "_flexcol _ai-c _gap-2"
}
const _hoisted_3 = { class: "_flex _gap-2" }
const _hoisted_4 = {
  key: 1,
  class: "_flex _jc-c _gap-1"
}
const _hoisted_5 = {
  key: 0,
  "data-qa": "faq-feedback-actions-helpful:Yes"
}
const _hoisted_6 = { "data-qa": "faq-feedback-actions-helpful:No" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_localize = _resolveComponent("localize")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, {
      slim: "",
      class: "_bxsh--none"
    }, {
      default: _withCtx(() => [
        (!$options.isUsefullness)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Faq.FeedbackFormParagraph), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_base_button, {
                  theme: "searchPrimary",
                  width: "compact",
                  weight: "thin",
                  shadow: "tight",
                  class: "_ttr",
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.markSectionUsefulness($props.section, true)), ["prevent"])),
                  "data-qa": "faq-feedback-actions-button:Yes"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "thumbs-up",
                      size: "lg",
                      class: "_mr-1 _tc--accent"
                    }),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.Resources.Common.ModalYesButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_base_button, {
                  theme: "searchPrimary",
                  width: "compact",
                  weight: "thin",
                  shadow: "tight",
                  class: "_ttr",
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.markSectionUsefulness($props.section, false)), ["prevent"])),
                  "data-qa": "faq-feedback-actions-button:No"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "thumbs-down",
                      size: "lg",
                      class: "_mr-1 _tc--accent"
                    }),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.Resources.Common.ModalNoButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($props.section.usefullness)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_base_icon, { name: "face-smile" }),
                    ($props.section.usefullness === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Faq.PositiveFeedbackSubmittedParagraph, $props.projectName)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_base_icon, { name: "heart-broken" }),
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_localize, {
                        resource: _ctx.Resources.Faq.NegativeFeedbackSubmittedParagraph
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "",
                            class: "gfu-link gfu-link--accent-plain",
                            "format-key": "0",
                            onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.onSectionNegativeFeedbackClick($props.section)), ["prevent"])),
                            "data-qa": "faq-feedback-actions-contact-link"
                          }, _toDisplayString(_ctx.Resources.Common.ClickHereButton), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["resource"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}